import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { ApplicationRef } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ResponseComponent } from './app/chatResponse/response/response.component';
import { UserResponseComponent } from './app/userResponse/user-response/user-response.component';

// bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));'

(async () => {
    const app: ApplicationRef = await createApplication(appConfig);
    customElements.define("app-response", ResponseComponent)
    customElements.define("app-user-response", UserResponseComponent)
    // Define Web Components
    const myAppComponent = createCustomElement(AppComponent, { injector: app.injector });
    customElements.define('app-q11bot', myAppComponent);
})();
